import { GetCrmoStatusCounters } from 'domain/usecases/surgical-order/get-crmo-status-counters'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'

export class RemoteGetCrmoStatusCounters implements GetCrmoStatusCounters {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  count(
    params: GetCrmoStatusCounters.Params
  ): Promise<GetCrmoStatusCounters.Model> {
    return this.surgicalOrderRepository.getCrmoStatusCounters(params)
  }
}
